import { usePosts } from "../../providers/Posts";
import Post from "../post/Post";
import SecondLine from "../secondLine/SecondLine";
import { Container, PostDiv } from "./thirdLineStyle";

const ThirdLine = () => {
  const { posts, degPostsCalc } = usePosts();

  return (
    <Container>
      <SecondLine />

      {posts.map((item, index) => {
        return degPostsCalc * index <= 93 || degPostsCalc * index >= 270 ? (
          <PostDiv key={item.id} $degPostsCalc={degPostsCalc} $index={index}>
            <Post
              name={item.title.rendered}
              categoriesId={item.categories}
              postId={item.id}
              casesId={item.acf.cases}
            />
          </PostDiv>
        ) : (
          <PostDiv key={item.id} $degPostsCalc={degPostsCalc} $index={index}>
            <Post
              $flip="true"
              name={item.title.rendered}
              categoriesId={item.categories}
              postId={item.id}
              casesId={item.acf.cases}
            />
          </PostDiv>
        );
      })}
    </Container>
  );
};

export default ThirdLine;
